/**
 * ``banking.*`` event schemas — placeholder for Phase 2+ module.
 *
 * The Banking module does not exist yet. Stub so the registry's
 * ``...bankingEvents`` spread is ready when the module ships. See
 * ``plans/PLAN_POSTHOG_02_EVENT_CATALOG.md`` § "Module-extension
 * pattern".
 */

export const bankingEvents = [] as const;
